<template>
  <div class="form">
    <header class="bg--secondary d--flex">
      <h2 class="header__title txt--white mt--1 mb--1 ml--2 mr--2 ml--1">
        Pathway Information
      </h2>
      <div class="header__cta mt--1 mb--1 mr--1">
        <q-button-icon icon="times" title="Close" @click="close" />
      </div>
    </header>
    <div class="scl">
      <div class="pt--2 pl--2 pr--2 pb--2 bg--white txt--black" @click.stop.prevent="handleClick">
        <q-display-label title="Pathway Name" :value="getPathwayName()"/>
        <q-display-label title="Authors" :value="getAuthors()" />
        <q-display-label title="Create Date" :value="getCreateDate()" />
        <q-display-label title="Last Updated Date" :value="getUpdateDate()" />
        <q-display-label title="Review Date" :value="getReviewDate()" v-if="reviewDate != undefined || reviewDate != null"/>
        <q-display-label title="More Information" :value="getDesc()" v-if="longDescription.length > 0" />
        <q-display-label title="Keywords" :value="getKeywords()" v-if="keywords.length > 0 && !keywords.includes('System.String[]')" />
        <q-display-label
          class="wysiwyg"
          title="Evidence Base"
					v-if="evidenceBase.length > 0"
          :html="getEvidenceBase()"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PathwayMetadata",
  data() {
    
    return {
      name: "",
      authors: "",
      createdDate: new Date(),
      updatedDate: new Date(),
      reviewDate: "",
      longDescription: "",
      keywords: "",
      evidenceBase: "",
      showKeyButton: "",
    };
  },
  created() {
    var self = this;
    if (typeof Native != "undefined") {
        self.name = document.getElementById("pathwayname").value;
        self.authors = document.getElementById("authors").value;
        self.longDescription = document.getElementById("longdescription").value;
        self.keywords = document.getElementById("keywords").value;
        self.showKeyButton = document.getElementById("showKeyButton").value;
        let reviewdate = document.getElementById("reviewdate").value;
        self.reviewDate =  reviewdate > -1
          ? new Date(
              reviewdate / 10000000000,
              (reviewdate % 10000000000) / 100000000 - 1,
              (reviewdate % 100000000) / 1000000,
              (reviewdate % 1000000) / 10000,
              (reviewdate % 10000) / 100,
              reviewdate % 100
            )
          : null;
          
    }
    this.$root.$on("loadPathwayMetadata", _js => {
      self.name = _js.Name;

      self.longDescription = _js.LongDescription;
      self.authors = _js.Authors;
      self.keywords = _js.Tags;

      self.reviewDate =
        _js.ReviewDate > -1
          ? new Date(
              _js.ReviewDate / 10000000000,
              (_js.ReviewDate % 10000000000) / 100000000 - 1,
              (_js.ReviewDate % 100000000) / 1000000,
              (_js.ReviewDate % 1000000) / 10000,
              (_js.ReviewDate % 10000) / 100,
              _js.ReviewDate % 100
            )
          : null;
      self.updatedDate = new Date(
        _js.LastUpdatedDate / 10000000000,
        (_js.LastUpdatedDate % 10000000000) / 100000000 - 1,
        (_js.LastUpdatedDate % 100000000) / 1000000,
        (_js.LastUpdatedDate % 1000000) / 10000,
        (_js.LastUpdatedDate % 10000) / 100,
        _js.LastUpdatedDate % 100
      );
      self.createdDate = new Date(
        _js.CreatedDate / 10000000000,
        (_js.CreatedDate % 10000000000) / 100000000 - 1,
        (_js.CreatedDate % 100000000) / 1000000,
        (_js.CreatedDate % 1000000) / 10000,
        (_js.CreatedDate % 10000) / 100,
        _js.CreatedDate % 100
      );
      self.evidenceBase = _js.EvidenceBase;
      self.showKeyButton = _js.ShowKeyButton;
    });
  },
  methods: {
    getPathwayName() {
      return this.name;
    },
    getAuthors() {
      return this.authors;
    },
    getCreateDate() {
      return this.createdDate
        .toLocaleString("en-GB", { timeZone: "UTC" })
        .substring(0, 25);
    },
    getUpdateDate() {
      return this.updatedDate
        .toLocaleString("en-GB", { timeZone: "UTC" })
        .substring(0, 25);
    },
    getReviewDate() {
      return this.reviewDate
            .toLocaleString("en-GB", { timeZone: "UTC" })
            .substring(0, 25);
    },
    getDesc() {
      return this.longDescription;
    },
    getKeywords() {
      return this.keywords;
    },
    getEvidenceBase() {
      return this.evidenceBase;
    },
    close() {
      this.$root.$emit("closePanel");
      this.$root.$emit("removeActiveNode");
    }
  }
};
</script>
